import * as ngCore from '@angular/core'
import * as store from '@attain-apps/fe/web/main/lib/store'

import * as admin from '../../admin'
import * as me from '../../me'
import * as resources from '../resources'

import { getActionsConfig } from './actions'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * Manages Quiver evaluations
 */
@ngCore.Injectable({ providedIn: 'root' })
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  constructor() {
    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'QuiverEvaluation',
      selectors: () => new Selectors(this),
    })
    const appsEc = ngCore.inject(admin.apps.Collection)
    const contextsFeature = ngCore.inject(admin.contexts.Feature)
    const meFeature = ngCore.inject(me.Feature)
    const resourcesEc = ngCore.inject(resources.Collection)

    this.registerEffects(
      effects.executeEvaluate(contextsFeature, resourcesEc),
      effects.executeDeploy(contextsFeature),
      effects.refreshAdminAppsOnDeploySuccess(appsEc, meFeature),
    )
  }
}
